import { createContext, useContext } from "react";

export interface AdminPreviewContextValue {
    previewClientId: number | null;
}

export const AdminPreviewContext = createContext<AdminPreviewContextValue>({
    previewClientId: null,
});

export function useAdminPreviewContext(): AdminPreviewContextValue {
    return useContext(AdminPreviewContext);
}
